import { t } from "@travily/i18n";
import { accountSettingsProfilePath } from "@travily/routes";
import { DropMenu, DropMenuItem, DropMenuPopover } from "@ui/components/DropMenu";
import { Icon } from "@ui/components/Icon";
import { OutlineButton } from "@ui/components/OutlineButton";
import { MenuTrigger } from "@ui/primitives/Menu";
import { FriendshipButton, type FriendshipStatus } from "@/components/FriendshipButton/FriendshipButton";
import { MessageButton } from "@/components/MessageButton/MessageButton";

export interface ActionBarProps {
  canDock?: boolean;
  canEdit: boolean;
  friendshipStatus: FriendshipStatus;
  handle: string;
  isDisabled: boolean;
  onAboutAccount?: () => void;
  onAcceptFriendship?: () => void;
  onDeclineFriendship?: () => void;
  onFriendshipAction?: () => void;
  onShareProfile?: () => void;
  onUnfriend?: () => void;
  /** Opens the account's friends list modal. Omit to drop the row (restricted profiles). */
  onViewFriends?: () => void;
  size: "36" | "40";
}

export function ActionBar({
  canDock,
  canEdit,
  friendshipStatus,
  handle,
  isDisabled,
  onAboutAccount,
  onAcceptFriendship,
  onDeclineFriendship,
  onFriendshipAction,
  onShareProfile,
  onUnfriend,
  onViewFriends,
  size,
}: ActionBarProps) {
  return (
    <>
      {canEdit ? (
        <OutlineButton href={accountSettingsProfilePath()} size={size}>
          {t("common.profile.edit_profile")}
        </OutlineButton>
      ) : (
        <>
          <FriendshipButton
            isDisabled={isDisabled}
            onAcceptFriendship={onAcceptFriendship}
            onDeclineFriendship={onDeclineFriendship}
            onPress={onFriendshipAction}
            onUnfriend={onUnfriend}
            size={size}
            status={friendshipStatus}
          />
          <MessageButton canDock={canDock} handle={handle} size={size} />
        </>
      )}
      <MenuTrigger>
        <OutlineButton aria-label={t("common.actions.more")} shape="circle" size={size}>
          <Icon name="more" />
        </OutlineButton>
        <DropMenuPopover placement="bottom">
          <DropMenu>
            {onViewFriends && (
              <DropMenuItem icon={<Icon name="people" />} onAction={onViewFriends}>
                {t("common.profile.friends")}
              </DropMenuItem>
            )}
            <DropMenuItem icon={<Icon name="infoCircle" />} onAction={onAboutAccount}>
              {t("common.profile.about_account")}
            </DropMenuItem>
            <DropMenuItem icon={<Icon name="share" />} onAction={onShareProfile}>
              {t("common.profile.share_profile")}
            </DropMenuItem>
            {friendshipStatus === "approved" && (
              <DropMenuItem icon={<Icon name="userX" />} onAction={onUnfriend}>
                {t("common.profile.unfriend")}
              </DropMenuItem>
            )}
          </DropMenu>
        </DropMenuPopover>
      </MenuTrigger>
    </>
  );
}
